import { gql, useLazyQuery } from "@apollo/client";

const ASK_FLASHDICE_RUN_QUERY = gql`
  query AskFlashDiceRunQuery($sql: String!, $user_id: Int!, $user_db_id: Int!, $db_type: String!) {
    askFlashDiceRunQuery(sql: $sql, user_id: $user_id, user_db_id: $user_db_id, db_type: $db_type)
  }
`;

export const useAskFlashDiceRunQuery = () => {
  const [runQueryLazy, { loading }] = useLazyQuery(ASK_FLASHDICE_RUN_QUERY, {
    fetchPolicy: "no-cache",
  });

  const runQuery = async ({ sql, user_id, user_db_id, db_type }) => {
    const { data, error } = await runQueryLazy({
      variables: { sql, user_id, user_db_id, db_type },
    });
    if (error) throw error;
    return data?.askFlashDiceRunQuery ?? null;
  };

  return { runQuery, loading };
};
